module.exports = __webpack_public_path__ + "img/chinesecompany71.ce08c017.png";